import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {DigitalOutDescription} from "./digitalOutDescription";
import {UrlBuilder} from "../url-builder/url.builder";

@Injectable({
  providedIn: 'root'
})
export class DigitaloutDescriptionDataservice {

  private uiUrl: string = "";
  private url: UrlBuilder;

  constructor(private http: HttpClient) {
    this.url = new UrlBuilder();
  }

  GetData(): Observable<DigitalOutDescription> {
    this.uiUrl = this.url.GetDigitalOutDescriptionUrl();
    console.log('FILE: ' + this.uiUrl);
    return this.http.get<DigitalOutDescription>(this.uiUrl);
  }



}

